<template>
  <div class="box">
    <el-carousel
      height="176px"
      autoplay
      :interval="5000"
      arrow="never"
    >
      <el-carousel-item
        v-for="item in list"
        :key="item.cover"
        @click.native="toPath(item)"
      >
        <el-image :src="oss + item.cover" style="height: 100%; width: 100%" />
      </el-carousel-item>
    </el-carousel>
    <bannerPopup  ref="bannerPopupRef"/>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import bannerPopup from "./bannerPopup.vue";
export default {
  name: "banner-carousel",
  components: { bannerPopup },
  data() {
    return {};
  },
  created() {
    this.getList({ team: 1 });
  },
  computed: {
    ...mapState("bannerList", ["list"]),
    ...mapState("app", ["oss"]),
  },
  methods: {
    ...mapActions("bannerList", ["getList"]),
    toPath({ url, type ,imageUrl}) {
      if (type === 1) {
        if (url) {
          window.open(url, "_blank");
        }
        return;
      }
      if (type === 2) {
        console.log(321);
        this.$refs.bannerPopupRef.onShow(this.oss + imageUrl);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 176px;
  border-radius: $border-radius;
  overflow: hidden;
  @include carouselIndicatorStyle;
}
</style>
